export function bannerSlider() {
    const $slider = $(".banners-with-link.one-in-row.slider");
    $slider.each(function () {
        let $this = $(this);
        $this.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            fade: true,
            infinite: true,
            arrows: false,
            dots: true,
            mobileFirst: true,
            autoplaySpeed: 6000,
            pauseOnHover: false,
            pauseOnFocus: false,
        });
    });
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            let slider = $(entry.target);
            if (entry.isIntersecting) {
                slider.addClass("slider-play").slick("slickPlay");
            } else {
                slider.removeClass("slider-play").slick("slickPause");
            }
        });
    });
    $slider.each(function () {
        observer.observe(this);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/bannerSlider.js